'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _PictureAsPdf = _interopRequireDefault(require("@material-ui/icons/PictureAsPdf"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
let app = window.app;
class JobAdsFrontList extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const candidate_id = app.state?.session?.user?.id;
    component.fetchJobAdsAndCompany(candidate_id);
  }
  fetchJobAdsAndCompany = candidate_id => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/jobad/get-all-with-company', {
      candidate_id: candidate_id
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        jobads: response.jobads
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let list = (state.jobads || []).filter(jobad => jobad.status === "Ouverte").map(function (jobad) {
      let output = /*#__PURE__*/_react.default.createElement(_Link.default, {
        className: "c-candidate-list__item",
        href: "/annonces/" + jobad.id
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "c-candidate-list__item__title"
      }, jobad.title, " - ", jobad._company.company_name), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--blue"
      }, "Type de contrat : ", jobad.contract_type), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--orange"
      }, "Salaire : ", jobad.salary), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--green"
      }, "Domaine professionnel : ", jobad._professional_domain.label), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-circle-decoration c-circle-decoration--pink"
      }, jobad?.duration_type), /*#__PURE__*/_react.default.createElement("p", {
        className: "c-candidate-list-details__location"
      }, jobad?.address?.postal_code));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidate-list"
    }, list);
    return output;
  }
}
exports.default = JobAdsFrontList;
